import React from "react";
import { Text } from "../../../core/design-system/Text";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, ChartOptions, Plugin } from "chart.js";
import { Img } from "../../../core/design-system/Img";
import { formatCurrency } from "../../../../utils/currencyFormatter";

Chart.register(ArcElement);
const centerTextPlugin: Plugin<"doughnut"> = {
  id: "centerTextPlugin",
  beforeDraw: (chart) => {
    const { ctx, width, height } = chart;
    ctx.save();

    const text1 = "Total Spent";
    const text2 = "50000";

    // Draw first line of text with opacity
    ctx.font = "1rem ";
    ctx.fillStyle = "rgba(0, 0, 0, 0.8)"; // Black with 0.8 opacity
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    const text1Y = height / 2.3;
    ctx.fillText(text1, width / 2, text1Y);

    // Draw second line of text with different font size and bold
    ctx.font = "bold 1.5rem ";
    ctx.fillStyle = "black"; // Fully opaque black
    const text2Y = text1Y + 25; // Adjust this value to set the distance between the two texts
    ctx.fillText(text2, width / 2, text2Y);

    ctx.restore();
  },
};

interface PieChartViewProps {}
const ExpenseItem: React.FC<{
  color: string;
  title: string;
  totalAmount: string;
  totalTransactions: number;
  percentage: number;
}> = ({ color, title, totalAmount, totalTransactions, percentage }) => {
  return (
    <div className="flex flex-row items-center gap-2 border border-lightGray px-2 py-4 rounded-lg">
      <div
        style={{ backgroundColor: color }}
        className={`flex size-10 rounded-3xl justify-center items-center`}
      >
        <Img src="shopping.svg" alt="shopping" />
      </div>
      <div className="flex flex-row justify-between items-center flex-1">
        <div className="flex flex-col">
          <Text className=" text-gray-50_04 !text-base text-left">{title}</Text>
          <Text className=" text-gray-50_04 text-sm opacity-50 text-left">
            {totalTransactions} transactions
          </Text>
        </div>

        <div className="flex flex-col items-end">
          <Text className=" text-gray-50_04 !text-base text-right">
            {totalAmount}
          </Text>
          <Text className=" text-gray-50_04 text-sm opacity-50 text-right">
            {percentage}%
          </Text>
        </div>
      </div>
    </div>
  );
};

const expencesData = [
  {
    color: "#F94144",
    title: "shopping",
    totalAmount: 44561,
    totalTransactions: 25,
    percentage: 25,
  },
  {
    color: "#90BE6D",
    title: "groceries",
    totalAmount: 2000,
    totalTransactions: 10,
    percentage: 10,
  },
  {
    color: "#F9C74F",
    title: "entertainment",
    totalAmount: 5000,
    totalTransactions: 15,
    percentage: 15,
  },
  {
    color: "#F8961E",
    title: "dining",
    totalAmount: 10000,
    totalTransactions: 20,
    percentage: 20,
  },
];

const PieChartView: React.FC<PieChartViewProps> = (props) => {
  const data = {
    labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
    datasets: [
      {
        label: "# of Votes",
        data: [12, 19, 3, 5, 2, 3],
        backgroundColor: [
          "#F94144",
          "#90BE6D",
          "#F9C74F",
          "#F8961E",
          "#2D9CDB",
        ],
        borderColor: ["#F94144", "#90BE6D", "#F9C74F", "#F8961E", "#2D9CDB"],
        borderWidth: 1,
        centerTextPlugin,
      },
    ],
  };

  const options: ChartOptions<"doughnut"> = {
    aspectRatio: 1.5,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  return (
    <div className="flex flex-col bg-gray p-4 rounded-lg w-100 border border-lightGray bg-gray-100_01 h-full">
      <div className="flex flex-col gap-8 bg-white p-3 rounded-lg bg-white-A700">
        <Text className=" text-gray-50_04 text-xl text-left">Expenses</Text>

        <Doughnut
          id={"doughnutChart"}
          data={data}
          options={options}
          plugins={[centerTextPlugin]}
        />
        <div className="flex flex-col gap-2">
          {expencesData.map((item, index) => (
            <ExpenseItem
              key={index}
              color={item.color}
              title={item.title}
              totalAmount={formatCurrency(item.totalAmount)}
              totalTransactions={item.totalTransactions}
              percentage={item.percentage}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PieChartView;
